import { render, staticRenderFns } from "./ContactPersonComponent.vue?vue&type=template&id=654c08e9"
import script from "./ContactPersonComponent.vue?vue&type=script&lang=js"
export * from "./ContactPersonComponent.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports